var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconfinder_LinkedIn_alt_367593","d":"M46.265,61.783H50.75V75.278H46.265Zm2.272-6.505a2.338,2.338,0,1,0-.059,4.662h.029a2.339,2.339,0,1,0,.03-4.662ZM61.76,61.466a4.452,4.452,0,0,0-4.042,2.227v-1.91H53.233c.059,1.266,0,13.495,0,13.495h4.486V67.742a3.088,3.088,0,0,1,.147-1.095,2.456,2.456,0,0,1,2.3-1.64c1.624,0,2.273,1.238,2.273,3.051v7.22h4.485V67.54C66.924,63.395,64.712,61.466,61.76,61.466Z","transform":"translate(-46 -55.278)","fill":"#222"}));
}

LinkedinInline.defaultProps = {"width":"20.924","height":"20","viewBox":"0 0 20.924 20"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
